import { api } from 'services/api'

export async function updateDevice(payload) {
  const { data } = await api.put('/devices', payload)

  return data
}
